import { loaderAction, setServiceFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { SERVICE_FORM_INITIAL } from "../initialStateConstant";
import { GetServicesSettingsThunk } from "./GetServicesSettingsThunk";

export const UpdateServiceThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('service_id', args.service_id);
        formData.append('name', args.name);
        formData.append('specialization_id', args.specialization_id);
        formData.append('price', args.price);
        formData.append('duration', args.duration);
        formData.append('net_duration', args.net_duration);
        formData.append('stop_booking', args.stop_booking);
        formData.append('stop_unbooking', args.stop_unbooking);
        formData.append('establishment', currentEstablishment);

        const response = await api({ data: formData, link: 'update_service' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            dispatch(setServiceFormAction(SERVICE_FORM_INITIAL));
            // Запрашиваем обновлённые данные
            dispatch(GetServicesSettingsThunk());

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};